import React, { useEffect, useState } from "react";
import BigCalendar from "../../../../components/BigCalendar/BigCalendar";
import Select, { components } from "react-select";
import { DropdownIndicator } from "../../../../utils/commonSelectBoxOptions/commonSelectBoxOptions";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import moment from "moment";
import { useSelector } from "react-redux";
import userRoleAuth from "../../../../utils/userRoleAuth/userRoleAuth";
import userRoles from "../../../../config/userRoles";

const FULL_DAY_LEAVE_MODE_ID = 2;
const FILTER_OPTIONS = {
  TEAM: "team",
};
const EMPLOYEE_OPTIONS = [
  { label: "All", value: "all" },
  { label: "My Team", value: "my" },
];
const EmployeeLeaveCalendar = () => {
  const loggedInUser = useSelector((state) => state.user.auth);
  const isHr = userRoleAuth(loggedInUser, userRoles.HR);
  const isAdmin = userRoleAuth(loggedInUser, userRoles.TENANTADMIN);
  const isAdminOrHR = isHr || isAdmin;

  const axiosPrivate = useAxiosPrivate();
  const [dateRange, setDateRange] = useState({
    fromDate: moment().startOf("month").format("YYYY-MM-DD"),
    toDate: moment().endOf("month").format("YYYY-MM-DD"),
  });
  const { fromDate, toDate } = dateRange;
  const [calendarData, setCalendarData] = useState([]);

  const [teamList, setTeamList] = useState([]);
  const [filters, setFilters] = useState({ employee_options: "my" });
  const [employeeDropdownValue, setEmployeeDropdownValue] = useState(
  EMPLOYEE_OPTIONS[1] // My Team
);

  const handleSetFilter = (value, source) => {
    setFilters((prev) => ({
      ...prev,
      [source]: value,
    }));
  };

  const fetchTeamList = async () => {
    let isMounted = true;
    const controller = new AbortController();

    await axiosPrivate
      .get("employee/teamlist", {
        signal: controller.signal,
      })
      .then((response) => {
        // console.log(response);
        if (response?.data?.status) {
          const formattedData = response?.data?.teams?.map((val) => ({
            label: val.team_name,
            value: val.id,
          }));
          setTeamList(formattedData);
        }
      })
      .catch((err) => {});

    return () => {
      isMounted = false;
      controller.abort();
    };
  };

  const formatCalendarData = (data) => {
    const formatedData = [];

    data.forEach((item) => {
      const isFullDay = Number(item.leave_mode_id) === FULL_DAY_LEAVE_MODE_ID;

      let backGroundColor = isFullDay ? "#86efac" : "#a78bfa";
      let borderColor = isFullDay ? "#16a34a" : "#7c3aed";

      if (
        filters.employee_options === "all" &&
        Number(item.is_my_employee) === 0
      ) {
        backGroundColor = "#fcd34d";
        borderColor = "#f59e0b";
      }

      formatedData.push({
        title: (
          <div>
            <p>{item.employee_name}</p>
          </div>
        ),
        details: (
          <div>
            <p className="text-xs">
              {item.department_name} {item.designation_title && "|"}{" "}
              {item.designation_title}
            </p>
            <p className="text-xs">Manager: {item.line_manager_name}</p>
            <p>
              {item.leave_name} | {item.leave_serial}
            </p>
            <p className="text-sm">
              {" "}
              Leave Duration:
              {item.leave_mode_id === FULL_DAY_LEAVE_MODE_ID
                ? `${item.duration_in_day} Day(s)`
                : `${item.duration_in_hour} Hour(s)`}
            </p>
          </div>
        ),
        start: new Date(item.from_date),
        end: new Date(item.to_date),
        backGroundColor,
        borderColor,
      });
    });

    setCalendarData(formatedData);
  };

  // employee leave list
  const fetchEmployeeLeaveList = async () => {
    const response = await axiosPrivate
      .get(`lms/leave/employeeLeaveList`, {
        params: {
          ...filters,
          from_date: fromDate,
          to_date: toDate,
        },
      })
      .then((res) => res)
      .catch((err) => err);
    if (response?.data?.status) {
      const data = response?.data?.results || [];
      formatCalendarData(data);
    } else {
      setCalendarData([]);
    }
  };

  useEffect(() => {
    if (teamList.length === 0) {
      fetchTeamList();
    }
    fetchEmployeeLeaveList();
  }, [dateRange, filters]);

  const handleChangeDate = (e) => {
    const { start, end } = e;
    if (start && end) {
      setDateRange({
        fromDate: moment(start).format("YYYY-MM-DD"),
        toDate: moment(end).format("YYYY-MM-DD"),
      });
    }
  };

  return (
    <div className="flex-1 px-10 pt-8 pb-6 border-b border-gray-200">
      <div className="mb-10">
        <h2 className="text-xl">Employee Leave</h2>
        <p>Manage and view all employee leavs</p>
        {/* Leave Color Legend */}
<div className="flex gap-6 text-sm text-gray-700 mb-6">
  <div className="flex items-center gap-2">
    <span className="w-3 h-3 rounded-full bg-green-400"></span>
    Full Day Leave
  </div>

  <div className="flex items-center gap-2">
    <span className="w-3 h-3 rounded-full bg-purple-400"></span>
    Half Day / Hourly Leave
  </div>

  <div className="flex items-center gap-2">
    <span className="w-3 h-3 rounded-full bg-yellow-400"></span>
    Other Team Member Leaves
  </div>
</div>

      </div>
      <div className="flex mb-5 gap-3">
        {/* <Select placeholder="All Employee" components={{ DropdownIndicator }} /> */}
        <Select
          placeholder="Team: All"
          isClearable
          onChange={(e) => handleSetFilter(e?.value, FILTER_OPTIONS.TEAM)}
          options={teamList}
          components={{ DropdownIndicator }}
        />
        {!isAdminOrHR && (
          <Select
            placeholder="Employee"
            isClearable
            options={[
              { label: "All", value: "all" },
              { label: "My Team", value: "my" },
            ]}
            value={employeeDropdownValue}
            onChange={(e) => {
              if (e === null) {
                handleSetFilter("my", "employee_options");
                setEmployeeDropdownValue(null);
              } else {
                handleSetFilter(e.value, "employee_options");
                setEmployeeDropdownValue(e);
              }
            }}
            components={{ DropdownIndicator }}
          />
        )}
      </div>
      <BigCalendar
        myEventsList={calendarData}
        handleChangeDate={handleChangeDate}
      />
    </div>
  );
};

export default EmployeeLeaveCalendar;
